export const fileName = (url) => url.substring(url.lastIndexOf('/') + 1)

export const buildFormData = (formData, data, parentKey) => {
	if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
		Object.keys(data).forEach(key => {
			buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
		})
	} else {
		const value = data == null ? '' : data

		formData.append(parentKey, value)
	}
}

export const toBase64 = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		console.log(file)
		reader.readAsDataURL(file)
		reader.onload = () => resolve(reader.result)
		reader.onerror = error => reject(error)
	})
}

export const currency = (number, local, symbol) => {
	if (!number || !local || !symbol) return null
	return new Intl.NumberFormat(local, { style: 'currency', currency: symbol }).format(number)
}



// WEBPACK FOOTER //
// ./src/utils/index.js